import React from 'react';
import { Field, FieldArray } from 'formik'; // import { Debug } from './Debug';

import { FormControlLabel, Grid } from '../../..';
import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      'flex-wrap': 'no-wrap',
      padding: '20px'
    },
    flex: {
      display: 'flex',
      'flex-wrap': 'wrap'
    }
  };
});

var RelatedTasksForm = function RelatedTasksForm(_ref) {
  var values = _ref.values,
      taskList = _ref.taskList,
      mode = _ref.mode;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(FieldArray, {
    name: "tasksDepends",
    render: function render(_ref2) {
      var push = _ref2.push,
          remove = _ref2.remove;
      return /*#__PURE__*/React.createElement("div", null, taskList.map(function (task) {
        return /*#__PURE__*/React.createElement(FormControlLabel, {
          className: classes.root,
          control: /*#__PURE__*/React.createElement(Field, {
            name: "taskIds",
            type: "checkbox" //	disabled={task.id === id}
            ,
            checked: values.tasksDepends.includes(task.key),
            color: "primary",
            value: task.key,
            disabled: mode === 'view',
            onChange: function onChange(e) {
              if (e.target.checked) push(task.key);else {
                remove(values.tasksDepends.indexOf(task.key));
              }
            }
          }),
          label: task.name
        }); // 					<Field
        // 						key={task.id}
        // name="taskIds"
        // 						type="checkbox"
        // 						value={task.id}
        // 						checked={values.tasksDepends.includes(task.id)}
        // 						onChange={(e) => {
        // 							if (e.target.checked) push(task.id);
        // 							else {
        // 								remove(values.tasksDepends.indexOf(task.id));
        // 							}
        // 						}}
        // 					>
        // 						{task.title}
        // 					</Field>
      }));
    }
  }));
};

export { RelatedTasksForm };